import { nomeFornecedor } from '../data';

export const termsOfUseData = [
  {
    subtitle: "TERMOS DE USO",
    paragraphs: [
      {
        text: `Ao acessar ou utilizar o aplicativo ou site ${nomeFornecedor}, você concorda em cumprir estes termos de uso, bem como todas as leis e regulamentos aplicáveis e, se você não concordar com qualquer parte destes termos, está proibido de acessar esse aplicativo ou site. Todo o conteúdo disponibilizado neste aplicativo ou site está protegido por leis de direitos autorais e outras leis de propriedade intelectual.`
      }
    ]
  },
  {
    subtitle: "Licença de Uso",
    paragraphs: [
      {
        text: `É concedida a você uma licença limitada para acessar e visualizar temporariamente o conteúdo disponível no aplicativo ou site ${nomeFornecedor} apenas para fins pessoais e não comerciais. Esta licença não constitui uma transferência de propriedade e está sujeita às seguintes restrições:`
      },
      {
        text: `- Você não pode modificar ou copiar o conteúdo;`
      },
      {
        text: `- Não é permitido utilizar o conteúdo para fins comerciais ou exibi-lo publicamente;`
      },
      {
        text: `- Você não pode tentar descompilar ou fazer engenharia reversa do aplicativo ou site;`
      },
      {
        text: `- Todos os avisos de direitos autorais e outras notações de propriedade devem ser mantidos intactos.`
      },
      {
        text: `Esta licença será automaticamente rescindida se você violar qualquer uma dessas restrições e pode ser rescindida pelo ${nomeFornecedor} a qualquer momento. Após o término da licença, você deve apagar todo o conteúdo baixado ou impresso do aplicativo.`
      }
    ]
  },
  {
    subtitle: "Isenção de Responsabilidade",
    paragraphs: [
      {
        text: `Todo o conteúdo disponibilizado no aplicativo ou site ${nomeFornecedor} é fornecido "no estado em que se encontra". O ${nomeFornecedor} não oferece garantias de qualquer tipo, expressas ou implícitas. Além disso, o ${nomeFornecedor} não garante a precisão, confiabilidade ou adequação do conteúdo para qualquer finalidade específica. O uso do conteúdo é por sua conta e risco.`
      }
    ]
  },
  {
    subtitle: "Limitação de Responsabilidade",
    paragraphs: [
      {
        text: `O ${nomeFornecedor} e seus fornecedores não serão responsáveis por quaisquer danos decorrentes do uso ou da incapacidade de usar o conteúdo do aplicativo, incluindo perda de dados, lucros ou interrupção dos negócios, mesmo que tenham sido avisados sobre a possibilidade de tais danos. Em jurisdições que não permitem a exclusão ou limitação de danos incidentais ou consequenciais, a responsabilidade do ${nomeFornecedor} será limitada até o limite máximo permitido por lei.`
      }
    ]
  },
  {
    subtitle: "Precisão do Conteúdo",
    paragraphs: [
      {
        text: `O ${nomeFornecedor} não garante a precisão, integridade ou atualidade do conteúdo disponibilizado no aplicativo. O conteúdo pode conter erros técnicos, tipográficos ou fotográficos. O ${nomeFornecedor} reserva-se o direito de fazer alterações ou atualizações no conteúdo sem aviso prévio.  No entanto, ${nomeFornecedor} não se compromete a atualizar os materiais.`
      }
    ]
  },
  {
    subtitle: "Links para Outros Sites",
    paragraphs: [
      {
        text: `O aplicativo ou site ${nomeFornecedor} pode conter links para sites de terceiros. O ${nomeFornecedor} não tem controle sobre o conteúdo desses sites e não será responsável por qualquer conteúdo ou danos decorrentes do uso desses sites. A inclusão de qualquer link no aplicativo não implica em endosso ou recomendação do ${nomeFornecedor}.`
      }
    ]
  },
  {
    subtitle: "Modificações nos Termos de Uso",
    paragraphs: [
      {
        text: `O ${nomeFornecedor} reserva-se o direito de revisar estes termos de uso a qualquer momento sem aviso prévio. Ao continuar a acessar ou usar o aplicativo após tais alterações, você estará concordando com os termos revisados.`
      }
    ]
  },
  {
    subtitle: "Lei Aplicável e Jurisdição",
    paragraphs: [
      {
        text: `Estes termos de uso são regidos e interpretados de acordo com as leis do ${nomeFornecedor}. Você concorda irrevogavelmente com a jurisdição exclusiva dos tribunais naquele estado ou localidade para resolver qualquer disputa relacionada a estes termos.`
      }
    ]
  }
];


export const privacyPolicyData = [
  {
    subtitle: `POLÍTICA DE PRIVACIDADE – ${nomeFornecedor}`,
    paragraphs: [
      {
        text: `Esta Política de Privacidade descreve como os dados pessoais são coletados, utilizados, armazenados e excluídos no contexto do aplicativo ${nomeFornecedor} e dos serviços disponibilizados por meio da plataforma.`,
      },
    ],
  },
  {
    subtitle: "1. Dados que podemos coletar e tratar",
    paragraphs: [
      {
        text: "1.1. Dados de cadastro e conta: nome, e-mail, telefone e demais informações necessárias para autenticação, suporte e uso do aplicativo.",
      },
      {
        text: "1.2. Dados de pagamento: o aplicativo pode oferecer compras e assinaturas (por exemplo, via gateway de pagamento e/ou faturamento in-app das lojas). Não armazenamos dados completos de cartão; recebemos, quando aplicável, identificadores e status da transação.",
      },
      {
        text: "1.3. Dados de uso e segurança: registros técnicos (ex.: logs de acesso, endereço IP, falhas e performance) para funcionamento, prevenção a fraude e segurança.",
      },
      {
        text: "1.4. Streaming: dados técnicos necessários para entrega e reprodução de conteúdo (ex.: parâmetros de sessão, dispositivo e reprodução).",
      },
      {
        text: "1.5. Funcionalidades opcionais por plano: podem existir notificações push e/ou comentários/comunidade. Quando habilitados, poderemos tratar tokens de notificação e conteúdos enviados (comentários/mensagens) e metadados associados.",
      },
      {
        text: "1.6. Dados de saúde (Health Data): caso o aplicativo disponibilize funcionalidades relacionadas à saúde, bem-estar ou acompanhamento físico, poderemos coletar dados fornecidos diretamente pelo usuário, como informações de atividades, ou métricas de saúde. Esses dados são coletados apenas mediante ação do usuário, utilizados exclusivamente para fornecer funcionalidades do aplicativo, não são compartilhados para fins publicitários e são tratados com alto nível de segurança.",
      },
    ],
  },
  {
    subtitle: "2. Finalidades do tratamento",
    paragraphs: [
      { text: "2.1. Disponibilizar autenticação, acesso ao conteúdo e operação das funcionalidades do aplicativo." },
      { text: "2.2. Processar pagamentos e liberar acesso a compras/assinaturas realizadas no aplicativo." },
      { text: "2.3. Viabilizar streaming e entrega de conteúdo." },
      { text: "2.4. Suporte, comunicação transacional, segurança e prevenção a fraude." },
      { text: "2.5. Enviar notificações (quando habilitado e permitido nas configurações do dispositivo)." },
      { text: "2.6. Personalizar a experiência do usuário e melhorar continuamente os serviços oferecidos." },
    ],
  },
  {
    subtitle: "3. Compartilhamento com terceiros",
    paragraphs: [
      { text: "3.1. Compartilhamos dados estritamente necessários com fornecedores essenciais para operar o serviço, como infraestrutura em nuvem, banco de dados e armazenamento." },
      { text: "3.2. Pagamentos: dados podem ser tratados por provedores de pagamento e/ou pelas lojas (Google Play / App Store) quando compras in-app estiverem habilitadas." },
      { text: "3.3. Streaming e entrega de conteúdo: dados técnicos podem ser tratados por provedores de entrega/streaming para permitir a reprodução do conteúdo." },
      { text: "3.4. Notificações: quando habilitado, tokens podem ser tratados por serviços de entrega de push notification." },
      { text: "3.5. Não vendemos dados pessoais. Compartilhamentos adicionais apenas ocorrerão para cumprir obrigações legais, proteger direitos, prevenir fraudes e garantir segurança." },
    ],
  },
  {
    subtitle: "4. Retenção e exclusão",
    paragraphs: [
      { text: "4.1. Mantemos os dados pessoais apenas pelo tempo necessário para cumprir as finalidades descritas nesta Política, incluindo obrigações legais, regulatórias e de auditoria." },
      { text: "4.2. Após o encerramento da conta ou solicitação de exclusão, os dados pessoais serão mantidos por até 30 dias para fins operacionais e, após esse período, serão excluídos ou anonimizados, salvo quando houver obrigação legal de retenção." },
      { text: "4.3. Dados que precisarem ser mantidos para cumprimento de obrigações legais ou regulatórias poderão ser armazenados pelo período exigido pela legislação aplicável." },
    ],
  },
  {
    subtitle: "5. Exclusão de dados",
    paragraphs: [
      { text: "5.1. O usuário pode solicitar a exclusão de seus dados pessoais a qualquer momento por meio das configurações do aplicativo, através da tela de edição de informações do perfil ou entrando em contato com o suporte." },
      { text: "5.2. Após a solicitação, os dados serão excluídos em até 30 dias, exceto quando houver necessidade de retenção por obrigação legal ou regulatória." },
    ],
  },
  {
    subtitle: "6. Segurança",
    paragraphs: [
      { text: "6.1. Adotamos medidas técnicas e organizacionais adequadas para proteger os dados pessoais contra acesso não autorizado, perda, alteração ou divulgação indevida, incluindo controles de acesso e criptografia de dados em trânsito." },
    ],
  },
  {
    subtitle: "7. Direitos do titular e solicitações",
    paragraphs: [
      { text: "7.1. Você pode solicitar acesso, correção, atualização e exclusão de dados pessoais, conforme aplicável, por meio dos canais de suporte disponibilizados." },
    ],
  },
  {
    subtitle: "8. Atualizações desta Política",
    paragraphs: [
      { text: "8.1. Esta Política poderá ser atualizada periodicamente. A versão vigente estará sempre disponível no aplicativo e em URL pública." },
    ],
  },
];

export const privacyData = termsOfUseData;